import { render, staticRenderFns } from "./ReportBarChart.vue?vue&type=template&id=180af2c1&"
import script from "./ReportBarChart.vue?vue&type=script&lang=js&"
export * from "./ReportBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports